import React, { useState, useEffect } from 'react';
import AppHeader from '../common/AppHeader';
import { FaCalendarAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import BottomNav from '../common/BottomNav';
import Toast from '../common/Toast';
import { useTranslation } from 'react-i18next';
import { getMembershipStatus } from '../../services/coreService';
import styles from '../css/AddService.module.css';

export default function AddService() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [showToast, setShowToast] = useState(false);
    const [message, setMessage] = useState("");

    useEffect(() => {
        const checkMembershipStatus = async () => {
            try {
                const user = JSON.parse(localStorage.getItem("user") || "{}");
                if (!user.spId) {
                    return;
                }

                const membershipStatus = await getMembershipStatus(user.spId);
                console.log('Membership status check:', membershipStatus);
                
                if (!(membershipStatus && membershipStatus.responseCode === 200 && membershipStatus.responseData)) {
                    // No active membership, show toast and redirect
                    setMessage(t('Membership.membership_required_message', 'Please activate your membership to add or manage listings.'));
                    setShowToast(true);
                    setTimeout(() => {
                        navigate('/membership');
                    }, 2000);
                }
            } catch (error) {
                console.error('Error checking membership:', error);
                setMessage(t('Membership.membership_required_message', 'Please activate your membership to add or manage listings.'));
                setShowToast(true);
                setTimeout(() => {
                    navigate('/membership');
                }, 2000);
            }
        };

        checkMembershipStatus();
    }, [navigate, t]);

    const serviceItems = [
        {
            label: t('AddService.add_listing', 'Add Listing'),
            icon: <FaCalendarAlt size={48} color="#ec4899" />,
            path: '/add-event-service',
            gradient: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
            bgColor: '#fef3f8',
            upcoming: false,
            desc: t('AddService.add_listing_desc', 'List your services in any category')
        }
    ];

    return (
        <div className={styles.addServiceContainer}>
            <AppHeader title={t("AddService.add_service", "Add Service")} showBack={true} />

            {/* Hero Section */}
            <div className={styles.addServiceHero}>
                <div className={styles.addServiceHeroCard}>
                    <div className={styles.addServiceHeroCircle1} />
                    <div className={styles.addServiceHeroCircle2} />
                    <div style={{ position: 'relative', zIndex: 1 }}>
                        <h2 className={styles.addServiceHeroTitle}>
                            {t("AddService.grow_your_business", "Grow Your Business")}
                        </h2>
                        <p className={styles.addServiceHeroDesc}>
                            {t("AddService.add_services_expand", "Add new services to expand your offerings and reach more customers.")}
                        </p>
                    </div>
                </div>
            </div>

            {/* Service Grid */}
            <div className={styles.addServiceGridWrapper}>
                <h3 className={styles.addServiceGridTitle}>
                    {t("AddService.choose_category", "Choose a Category")}
                </h3>
                <div className={styles.addServiceGrid} style={{ gridTemplateColumns: '1fr', gap: '20px', maxWidth: '500px', margin: '0 auto' }}>
                    {serviceItems.map((item, index) => (
                        <div
                            key={item.label}
                            className={`${styles.addServiceGridItem} ${item.upcoming ? styles.upcoming : ''}`}
                            onClick={() => { if (!item.upcoming) navigate(item.path); }}
                            style={{
                                animationDelay: `${index * 0.1}s`,
                                background: '#fff',
                                border: '1px solid rgba(0, 0, 0, 0.04)',
                                padding: '32px 24px',
                                minHeight: '180px'
                            }}
                        >
                            <div className={styles.addServiceIcon} style={{ 
                                background: item.bgColor,
                                width: '80px',
                                height: '80px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                {item.icon}
                            </div>
                            <span className={styles.addServiceLabel} style={{ fontSize: '20px', fontWeight: '600' }}>{item.label}</span>
                            <span className={styles.addServiceDesc} style={{ fontSize: '15px' }}>{item.desc}</span>
                            {item.upcoming && (
                                <span className={styles.addServiceSoon}>
                                    {t("AddService.coming_soon", "SOON")}
                                </span>
                            )}
                        </div>
                    ))}
                </div>
                
                {/* Info Card */}
                <div className={styles.addServiceInfoCard}>
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                        <div className={styles.addServiceInfoIcon}>
                            <span style={{ fontSize: 18 }}>💡</span>
                        </div>
                        <div>
                            <h4 className={styles.addServiceInfoTitle}>
                                {t("AddService.quick_tip", "Quick Tip")}
                            </h4>
                            <p className={styles.addServiceInfoDesc}>
                                {t("AddService.tip_desc", "Upload clear photos and accurate details to attract more customers and get better bookings.")}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {showToast && (
                <Toast
                    message={message}
                    success={false}
                    onClose={() => setShowToast(false)}
                />
            )}
            <BottomNav />
        </div>
    );
}